import { utils } from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";
import { QUARRY_ADDRESSES } from "../../constants";
export const findRegistryAddress = async (rewarderKey, programID = QUARRY_ADDRESSES.Registry) => {
    return await PublicKey.findProgramAddress([utils.bytes.utf8.encode("QuarryRegistry"), rewarderKey.toBytes()], programID);
};
//# sourceMappingURL=pda.js.map